module.exports = require("react-redux");


//////////////////
// WEBPACK FOOTER
// external "react-redux"
// module id = 541
// module chunks = 0